module.exports = __webpack_public_path__ + "static/media/1.2c0bfb03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mogilev/1.jpg
// module id = 234
// module chunks = 0